import { z } from "zod";
import {
  scopedId,
  assignmentSchema,
  AccessError,
  type Assignment,
} from "./contracts";
const legacyMemberships = z.array(
  z
    .object({
      version: z.literal(1),
      tenantId: scopedId,
      subjectId: scopedId,
      role: z.enum(["user", "admin"]),
      revision: z.number().int().positive(),
    })
    .strict(),
);
/** Pure host-boundary migration; conflicts require an authoritative host decision. */
export function migrateLegacyMemberships(raw: unknown): Assignment[] {
  const records = new Map<string, Assignment>();
  for (const item of legacyMemberships.parse(raw)) {
    const key = JSON.stringify([item.tenantId, item.subjectId]),
      role = item.role === "admin" ? "tenant.administrator" : "tenant.tester",
      prior = records.get(key);
    if (prior && prior.roleIds[0] !== role)
      throw new AccessError("LEGACY_MEMBERSHIP_CONFLICT", 409);
    const revision = Math.max(prior?.authorizationRevision || 0, item.revision);
    records.set(
      key,
      assignmentSchema.parse({
        version: 1,
        tenantId: item.tenantId,
        subjectId: item.subjectId,
        roleIds: [role],
        assignmentRevision: revision,
        authorizationRevision: revision,
      }),
    );
  }
  return [...records.entries()]
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
    .map(([, v]) => v);
}
